const attributes = {
  count: 'data-cart-count',
  limit: 'data-limit',
};

class CartCount extends HTMLElement {
  constructor() {
    super();

    this.cartCount = null;
    this.limit = this.getAttribute(attributes.limit);
    this.onCartChangeCallback = this.onCartChange.bind(this);
  }

  connectedCallback() {
    document.addEventListener('theme:cart:change', this.onCartChangeCallback);
  }

  disconnectedCallback() {
    document.addEventListener('theme:cart:change', this.onCartChangeCallback);
  }

  onCartChange(event) {
    this.cartCount = event.detail.cartCount;
    this.update();
  }

  update() {
    if (this.cartCount !== null) {
      this.setAttribute(attributes.count, this.cartCount);
      let countValue = this.cartCount;
      const desktopEmptyCartButton = document?.querySelector('.header__desktop__button .desktop-open-empty-cart');
      const desktopFullCartButton = document?.querySelector('.header__desktop__button .desktop-open-full-cart');
      const mobileEmptyCartButton = document?.querySelector('.header__mobile__button .mobile-open-empty-cart');
      const mobileFullCartButton = document?.querySelector('.header__mobile__button .mobile-open-full-cart');

      if (countValue >= 1) {
        document.querySelector('[data-header-wrapper]').classList.remove('header__mobile__flex');

        desktopEmptyCartButton.classList.add('hidden');
        desktopFullCartButton.classList.remove('hidden');

        mobileEmptyCartButton.classList.add('hidden');
        mobileFullCartButton.classList.remove('hidden');

        if (this.closest('.drawer__body')) {
          this.classList.remove('hidden');
        }
      } else {
        document.querySelector('[data-header-wrapper]').classList.add('header__mobile__flex');
        desktopEmptyCartButton.classList.remove('hidden');
        desktopFullCartButton.classList.add('hidden');

        mobileEmptyCartButton.classList.remove('hidden');
        mobileFullCartButton.classList.add('hidden');

        if (this.closest('.drawer__body')) {
          this.classList.add('hidden');
        }
      }

      if (this.limit && this.cartCount >= this.limit) {
        countValue = '9+';
      }

      this.innerText = countValue;
    }
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount);
}
